import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

const isFullyVisible = (element: Element) => {
  const { top, bottom } = element.getBoundingClientRect()
  return top >= 0 && bottom <= window.innerHeight
}

// Attach the returned ref to the form's submit button. After a submit attempt,
// scrolls to the first field rendered in an error state. Looks at the DOM rather
// than Formik's validity so that errors a submit handler raises for fields kept
// outside Formik (the check-in note's linked call) are scrolled to as well.
const useScrollToFirstError = <T extends HTMLElement>() => {
  const ref = useRef<T>(null)
  const { isSubmitting, submitCount } = useFormikContext()

  useEffect(() => {
    if (isSubmitting || submitCount === 0) return
    const firstError = ref.current?.closest('form')?.querySelector('.Mui-error')
    if (!firstError) return
    const field = firstError.closest('.MuiFormControl-root') ?? firstError
    if (isFullyVisible(field)) return
    field.scrollIntoView?.({ behavior: 'smooth', block: 'center' })
  }, [isSubmitting, submitCount])

  return ref
}

export default useScrollToFirstError
